// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-3qxa8";
var _3 = "header-31y5_";
var _4 = "label-1Lwda";
export { _1 as "__esModule", _2 as "root", _3 as "header", _4 as "label" }
export default { "__esModule": _1, "root": _2, "header": _3, "label": _4 }
